<template>
  <v-dialog width="70%" persistent :value="previewJobDialog">
    <v-card v-if="previewJobDialog">
      <v-card-title>Job Sheet <span class="ml-4" v-if="activeBooking.xeroInvoiceNumber"><a
          :href="activeBooking.xeroInvoiceLink" target="_blank">{{ activeBooking.xeroInvoiceNumber }}</a></span>
        <span v-if="activeBooking.history && activeBooking.history.length === 0"> - New Customer</span>
        <p class="display-1" v-if="activeBooking.isPayingCash">THIS IS A CASH PAYMENT - ENSURE CASH IS COLLECTED</p>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" v-if="invoice">
            <h5 class="display-1">Invoice Status: {{invoice.body.invoices[0].status}}</h5>
          </v-col>
          <v-col>
            <p>Service: {{ activeBooking.valet }}</p>
<!--            <p>Description: {{ activeBooking.valetDescription }}</p>-->
            <p v-if="activeBooking.price && !activeBooking.isParent">Price:
              £{{ parseFloat(activeBooking.price).toFixed(2) }}</p>
            <p v-if="activeBooking.isParent && activeBooking.selectedServices && activeBooking.selectedServices.length > 0">
              Price: £{{ activeBooking.selectedServices[0].unitPrice }}</p>
            <p v-if="activeBooking.totalCharged">Paid: £{{ parseFloat(activeBooking.totalCharged).toFixed(2) }}</p>
            <p>Customer: {{ activeBooking.customer.name }}</p>
            <p>Phone: {{ activeBooking.customer.phone }}</p>
            <p>Mobile: {{ activeBooking.customer.mobile }}</p>
            <p>Booking Made By: {{ activeBooking.bookingMadeBy }}</p>
          </v-col>
          <v-col>
            <p>Email: {{ activeBooking.customer.email }}</p>
            <p>Address: <br/>
              {{ activeBooking.customer.address1 }}
              <br/>
              {{ activeBooking.customer.address2 }}
              <br/>
              {{ activeBooking.customer.city }}
              <br/>
              {{ activeBooking.customer.county }}
              <br/>
              <span>{{ activeBooking.customer.postcode }}</span>
            </p>
            <div v-if="activeBooking.customer.additionalAddress">
              <p>Valet Location Address: <br/>
                {{ activeBooking.customer.addAddress1 }}
                <br/>
                {{ activeBooking.customer.addAddress2 }}
                <br/>
                {{ activeBooking.customer.addCity }}
                <br/>
                {{ activeBooking.customer.addCounty }}
                <br/>
                <span>{{ activeBooking.customer.addPostCode }}</span>
              </p>
            </div>
            <div v-if="activeBooking.history && activeBooking.history.length > 0">
              <h5 class="display-1">History</h5>
              <p v-for="(h, i) in activeBooking.history" :key="i">{{ h.name }} - {{ h.date | moment('DD/MM/YYYY') }}</p>
            </div>
          </v-col>
        </v-row>
        <v-divider/>
        <v-row>
          <v-col>
            <div v-if="activeBooking.vehicles">
              <div v-for="(v, i) of activeBooking.vehicles" :key="i">
                <p>Car: {{v.make}} - {{v.model}}</p>
                <p>Registration: {{v.registration}}</p>
                <p>Mileage: {{v.mileage}}</p>
                <p>Colour: {{v.colour}}</p>
                <p>Usage: {{v.usage}}</p>
              </div>
              <p>Description: {{activeBooking.description}}</p>
              <p>Notes: {{activeBooking.notes}}</p>
              <p>Up-sell Opportunities: {{activeBooking.upsellOptions}}</p>

            </div>
            <div v-if="!activeBooking.vehicles">
              <p>Car: {{activeBooking.customer.make}} - {{activeBooking.customer.model}}</p>
              <p>Registration: {{activeBooking.customer.registration}}</p>
              <p>Mileage: {{activeBooking.customer.mileage}}</p>
              <p>Description: {{activeBooking.description}}</p>
              <p>Notes: {{activeBooking.notes}}</p>
              <p>Up-sell Opportunities: {{activeBooking.upsellOptions}}</p>
            </div>
          </v-col>
          <v-col>
            <p>Start: {{ activeBooking.startDate | moment('DD/MM/YYYY HH:mm') }}</p>
            <p>End: {{ activeBooking.endDate | moment('DD/MM/YYYY HH:mm') }}</p>
            <p>Reason for Valet: {{ activeBooking.purpose }}</p>
            <p>Power: {{activeBooking.hasPower}}</p>
            <p>Water: {{activeBooking.hasWater}}</p>
            <p>Can be re-arranged: {{activeBooking.canBeChanged}}</p>
            <p>Invoice Number: {{ activeBooking.xeroInvoiceNumber }}</p>
            <p>Technician: {{ activeBooking.xeroValetTrackingId }}</p>
            <p>Commission Period: {{ activeBooking.xeroCommissionTrackingId }}</p>
            <p>Commission Basis: {{ activeBooking.xeroAccountName }}</p>
            <p v-if="activeBooking.xeroAccountName !== 'Sales (30%)'">Commission Reason: {{ activeBooking.xeroAccountCodeReason }}</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="activeBooking.isApproved" color="error" @click="deleteBooking">Delete</v-btn>
        <v-btn color="secondary" @click="printBooking">Print</v-btn>
        <v-btn color="primary" @click="cancelBooking">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import EventBus from '../../EventBus';
import {XeroHttp} from "@/http/XeroHttp";

export default {
  name: "BookingDetailsPreviewModal",
  computed: {
    ...mapState('bookings', ['previewJobDialog', 'activeBooking'])
  },
  data() {
    return {
      isLoading: false,
      invoice: null
    }
  },
  methods: {
    ...mapActions("bookings", ["setPreviewJobDialog", "setActiveBooking", "setManageDeleteBookingDialog"]),
    ...mapMutations("app", ["setToast"]),
    async cancelBooking() {
      this.invoice = null;
      await this.setActiveBooking({isXeroBooking: true, customer: {}});
      await this.setPreviewJobDialog(false);
    },
    async deleteBooking() {
      await this.setManageDeleteBookingDialog(true);
    },
    printBooking() {
      window.open(`/work/${this.activeBooking._id}`);
    },
    copyToClipboard(postcode) {
      const self = this;
      this.$clipboard(postcode);
      self.setToast({color: 'success', text: `Copied Postcode - ${postcode}`, show: true});
    }
  },
  mounted() {
    EventBus.$on('booking-deleted', () => this.setPreviewJobDialog(false))
  },
  watch: {
    async previewJobDialog(newVal) {
      if (newVal) {
        // eslint-disable-next-line no-console
        console.log(this.activeBooking);
        if (!this.activeBooking.isEntry) {
          this.invoice = await XeroHttp.getInvoice(this.activeBooking.xeroInvoiceNumber).then(result => result.data);
        }
      }
    }
  }
}
</script>
